import * as React from 'react';

export const MainLayout: React.FC = (props) => {
	return <div className="content">
		{props.children}
	</div>;
};
